<template>
    <!-- Article Content Section -->
    <div class="relative mb-24">                                   
      <div v-if="article" >
        <div class="htmlcontent" v-html="article.contenthtml"></div>
      </div>
    </div>

   
</template>
  
  <script setup>
  import { computed } from 'vue';
  import { useBlogStore } from '@/stores/blogStore';

  const blogStore = useBlogStore();
  const pageStore = usePageStore();
  // Props
  const props = defineProps({
    article: {
      type: Object,
      required: true,
    },
  });
  

</script>

<style>
@reference "../../assets/css/main.css";

.htmlcontent div {
    display: flex;
    flex-direction: row;

  }
  .htmlcontent div img{
    width: 100%;
  }
  
  
.htmlcontent div img {
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  @apply max-w-6xl mx-auto;
}
/* Target divs containing exactly 2 images */
.htmlcontent div:has(img:first-child + img:last-child) {
  display: flex;
  gap: 28px; /* Space between images */
  justify-content: center;
  @apply max-w-6xl mx-auto;
  margin-top: 76px; /* Adds space top of img in div */
  margin-bottom: 76px; /* Adds space bottom of img in div */

}

/* Target divs containing exactly 3 images */
.htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) {
  display: flex;
  gap: 28px; /* Adjust spacing between images */
  justify-content: center;
  align-items: center;
  flex-wrap: wrap; /* Ensures responsiveness */
  @apply max-w-6xl mx-auto;
}

/* Style individual images within the 3 images targeted div */
.htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) img {
  width: calc(33.333%); /* Adjusts width to fit three images with spacing */
  max-width: 364px; /* Prevents excessive scaling */
  height: auto;
  object-fit: cover;
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  /* Adjust 3-image layout on small screens */
  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) {
    gap: 12px; /* Reduce spacing between images */
  }

  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) img {
    width: 31%;
  }

  /* Adjust margin-bottom for the parent div on small screens */
  .relative.mb-24 {
    margin-bottom: 16px; /* Reduce margin-bottom */
  }
}
@media (max-width: 1024px) {
  /* Adjust 3-image layout for iPad Pro */
  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) {
    gap: 20px; /* Adjust spacing between images */
    flex-wrap: nowrap; /* Prevent wrapping */
  }

  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) img {
    width: calc(33.333% - 13.33px); /* Ensure images fit in one row */
    max-width: none; /* Remove scaling limit */
  }
}

/* Adjust size on glitchy sizes */
@media (min-width: 1024px) and (max-width: 1148px) {
  /* Adjust 3-image layout for screens between 1024px and 1148px */
  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) {
    gap: 16px; /* Adjust spacing between images */
    flex-wrap: nowrap; /* Prevent wrapping */
  }

  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) img {
    width: 33%; /* Ensure images fit in one row */
    max-width: none; /* Remove scaling limit */
  }
}

@media (max-width: 640px) {
  /* Adjust 3-image layout for extra-small screens */
  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) {
    gap: 14px; /* Reduce spacing between images */
  }

  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) img {
    width: 33%; /* Adjust image width for smaller screens */
  }
}

@media (max-width: 480px) {
  /* Adjust 3-image layout for very small screens */
  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) {
    gap: 10px; /* Further reduce spacing between images */
  }

  .htmlcontent div:has(img:nth-child(1) + img:nth-child(2) + img:nth-child(3):last-child) img {
    width: 33%; /* Further adjust image width */
  }
}




/* Ensure <p> containing ONLY an image behaves like other text elements */
  .htmlcontent p:has(img:only-child) {
  max-width: 48rem; /* Same width as text elements */
  text-align: center; /* Keeps alignment consistent */

}

/* Make images inside <p> behave like text */
.htmlcontent p:has(img:only-child) img {
  width: 100%;
  height: auto;
  display: block;
}

/* Target <p> elements containing exactly 2 images */
  .htmlcontent p:has(img:first-child + img:last-child) {
  display: flex;
  gap: 28px; /* Same gap as div with 2 images */
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 48rem; /* Matches text width */
  text-align: center;
  margin: 0 auto; /* Centers the content */
  margin-top: 76px; /* Adds space top of img in div */
  margin-bottom: 76px; /* Adds space bottom of img in div */
}

/* Ensure images inside <p> behave like two side-by-side elements */
.htmlcontent p:has(img:first-child + img:last-child) img {
  width: calc(50% - 14px); /* Makes two images fit nicely */
  max-width: 400px; /* Prevent excessive stretching */
  height: auto;
  object-fit: cover;
}


  .htmlcontent h1, .htmlcontent h2 .htmlcontent h3, .htmlcontent h4, .htmlcontent h5, .htmlcontent p {
    @apply max-w-3xl px-11 mx-auto;
  }

  /* Add margin to headings */
  .htmlcontent h1, .htmlcontent h2 .htmlcontent h3, .htmlcontent h4, .htmlcontent h5 {
    @apply mt-4;
  }

  .btn {
  transition: transform 0.2s ease-in-out; /* Smooth transition */
}

.btn:hover {
  transform: scale(1.03); /* Slightly increase size on hover */
}


</style>